import {
  Component,
  computed,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import {
  GcInputFieldComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { PageSizePickerComponent } from '../page-size-picker/page-size-picker.component';

export interface TableToolbarConfig {
  pageSizePicker?: PageSizePickerConfig;
  searchInput?: {
    value: string | null;
    placeholder?: string;
  };
}
export interface PageSizePickerConfig {
  itemsPerPageOptions?: number[];
  allowAll: boolean;
  currentItemsPerPage: number | null;
  label?: string;
}

@Component({
  selector: 'app-table-toolbar',
  imports: [GcInputFieldComponent, PageSizePickerComponent, IpoTranslatePipe],
  templateUrl: './table-toolbar.component.html',
  styleUrl: './table-toolbar.component.scss',
})
export class TableToolbarComponent {
  data = input.required<TableToolbarConfig>();

  itemsPerPageSelected = output<number | null>();
  searchInputChanged = output<string>();

  localItemsPerPage = signal<number | null>(null);
  localSearchInputValue = signal<string | null>(null);

  pageSizePicker = computed<PageSizePickerConfig | undefined>(
    () => this.data().pageSizePicker,
  );

  startIndex = computed<number | null>(() => this.calculateStartIndex());

  constructor() {
    effect(() => {
      this.setLocalItemsPerPage();
      this.setLocalSearchInputValue();
    });
  }

  calculateStartIndex(): number | null {
    const data = this.pageSizePicker();
    if (data === undefined) return null;

    const perPage = this.localItemsPerPage();
    if (perPage === null) return null;

    const options = data.itemsPerPageOptions ?? [];
    const idx = options.indexOf(perPage);
    return idx >= 0 ? idx : 0;
  }

  setLocalItemsPerPage(): void {
    const value = this.data().pageSizePicker?.currentItemsPerPage ?? null;
    if (this.localItemsPerPage() !== value) {
      this.localItemsPerPage.set(value);
    }
  }

  setLocalSearchInputValue(): void {
    const value = this.data().searchInput?.value ?? null;
    if (this.localSearchInputValue() !== value) {
      this.localSearchInputValue.set(value);
    }
  }

  onItemsPerPageSelected(option: number | null): void {
    this.localItemsPerPage.set(option);
    this.itemsPerPageSelected.emit(option);
  }

  onSearchInputChanged(inputString: string): void {
    this.localSearchInputValue.set(inputString);
    this.searchInputChanged.emit(inputString);
  }
}
